import React, { useEffect, useState } from 'react';
import Header from './components/Headers/Header';
import Signin from './components/SignIn/Signin';
import Signup from './components/SignUp/Signup';
import Forgotpassword from './components/Forgotpassword/Forgotpassword';
import UserManagement from './components/UserManagement/UserManagement';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import UsersDashboard from './components/Dashboard/UsersDashboard';
import { ProtectedRoute } from './routes/protectedRoutes';
import { UserRoute } from './routes/userRoutes';
import ResetPassword from './components/Forgotpassword/ResetPassword';
import ChangeAdminPassword from './components/Forgotpassword/ChangeAdminPassword';
import PasswordUpdated from './components/Forgotpassword/PasswordUpdated';
import DataManagement from './components/DataManagement/DataManagement';
import WelcomeNewUser from './components/SignUp/Welcome';
import API_PATH from "./constants/config.json";
import MidblockDetails from './components/StationDetails/Midblock/MidblockDetails';
import IntersectionDetails from './components/StationDetails/Intersection/IntersectionDetails';
import PrivacyPolicy from './components/Information/PrivacyPolicy';
import { isLogin, clearCookie, setCookie } from './functions/Auth';
import FileImportRequirementsAndBestPractices from './components/Information/FileImportRequirementsAndBestPractices';
import Footer from './components/Footer/Footer';
import Cookies from 'js-cookie';
import Help from './components/Information/Help';
import UnderMaintanance from './components/Information/UnderMaintanance';
import PageNotFound from './components/Information/PageNotFound';
/** version 2 **/
import MapViewv2 from './components_v2/MapView/MapView';
import Headerv2 from './components_v2/Headers/Header';
import SignIn from './components_v2/SignIn/SignIn';
import SignUp from './components_v2/SignUp/SignUp';
import ForgotPassword from './components_v2/ForgotPassword/ForgotPassword';
import ResetPasswordV2 from './components_v2/ForgotPassword/ResetPassword';
import PasswordUpdatedV2 from './components_v2/ForgotPassword/PasswordUpdated';
import HelpV2 from './components_v2/Information/Help';
import UsersDashboardV2 from './components_v2/Dashboard/UsersDashboard';
import MapContext from './context/MapContext';
import PrivacyPolicyV2 from './components_v2/Information/PrivacyPolicy';
import Welcome from './components_v2/SignUp/Welcome';

import IntersectionFullScreen from './components_v2/StationDetails/Intersection/FullScreen';
import MidblockFullScreen from './components_v2/StationDetails/Midblock/FullScreen';
import FileImport from './components_v2/Information/FileImport';
import PageNotFoundv2 from './components_v2/Information/PageNotFound';
import ChangeAdminPasswordv2 from './components_v2/ForgotPassword/ChangeAdminPassword';


const axios = require('axios');
axios.defaults.withCredentials = true;
const API_URL = process.env.REACT_APP_BASE_URL;


const App = () => {
  let versionNum = 2;
  
  let history = useHistory();
  const [loading, isLoading] = React.useState(true);
  let timer = 3300000 - 300000; // 55 minutes interval to refresh tokens

  const initialFilter={
    volume:false,
    class:false,
    speed:false,
    turn:false,
    pedestrian:false,
    bicycle:false,
    startDate:"",
    endDate:"",
    intersection_type:{
      signal : false,
      stop: false,
      roundabout: false,
      unknown: false,
    },
    storageFileTerms: [],
    storageFileOperator: 'OR',
    storageFileFilterActive: false,
    storageFileFromDate: null,
    storageFileToDate: null,

  }

  const hiddenAgency = {
    visible : true,
    name : null
  }
  
  const [ filter, setFilter]= useState(initialFilter)
  const [ filterisactive, setFilterisactive]= useState(false)
  const [ searchEnabled, setSearchEnabled]= useState(false)  
  const [ addNewStation, setAddNewStation]= useState(false)
  const [ getUpdateStationDetails, setUpdateStationDetails]= useState(false)
  const [ midAndIntFiltersIsHidden, setMidAndIntFiltersHidden]= useState(false);
  const [ midAndIntAndDateFilters, setMidAndIntAndDateFilters]= useState(false);
  const [ suggestStartActive, setSuggestStartActive]= useState(false);
  const getSearchEnabled =(data)=>{
    setSearchEnabled(data);
  }
  const [ agenciesEnabled, setAgenciesEnabled]= useState(hiddenAgency)

  const enabledAgency =(data)=>{
    setAgenciesEnabled(data);
  }

  const clearFilterYear=()=>{
    
    setFilter({...filter,
          
      startDate:"",
      endDate:""})
}
  const clearFilterMid=()=>{
    
    setFilter({...filter,
          
      volume:false,
      class:false,
      speed:false})
}

  const clearFilterInt = () => {
    setFilter({
      ...filter,
      turn: false,
      pedestrian: false,
      bicycle: false,
      intersection_type: {
        signal: false,
        stop: false,
        roundabout: false,
        unknown: false,
      }
    })
  }
const updateMainFilter =(key,value) => {
  
  setFilter({...filter,
            [key]:value})
  
}
const updateMainFilterstart =(key,value) => {
  
  setFilter({...filter,
            [key]:value})
}
const updateMainFilterend =(key,value) => {
  
  setFilter({...filter,
            ['endDate']:value})
}

useEffect(() => {
}, [initialFilter])  


  const updateMainFilterByIntersectionType = (key, value) => {
    setFilter({
      ...filter,
      intersection_type: {
        ...filter.intersection_type,
        [key]: value
      }
    });
  }

const clearMainFilter =() => {
 
  setFilter(initialFilter)
  //updateFilterisactive(false)
  
}
const updateFilterisactive =(value)=>{
  setFilterisactive(value)
}
const updAddNewStation =(station)=>{
  setAddNewStation(station)
}
const updateStationDetails =(station)=>{
  setUpdateStationDetails(station)
}
const setHiddenMidAndIntFilters =(value)=>{
  setMidAndIntFiltersHidden(value)
}
const setActiveSuggestStart = (value) =>{
  setSuggestStartActive(value);
}
const clearStorageFileFilter = () => {
  setFilter(prev => ({
    ...prev,
    storageFileTerms: [],
    storageFileOperator: 'OR',
    storageFileFilterActive: false,
    storageFileFromDate: null,
    storageFileToDate: null,
  }));
}
const filterdata={clearFilterYear, clearFilterMid,clearFilterInt,clearStorageFileFilter,versionNum, filterisactive,updateFilterisactive,filter,updateMainFilter,clearMainFilter,updateMainFilterstart,updateMainFilterend, updateMainFilterByIntersectionType, agenciesEnabled,enabledAgency, setFilter,getSearchEnabled,setSearchEnabled,searchEnabled,updAddNewStation,addNewStation,updateStationDetails,getUpdateStationDetails,midAndIntFiltersIsHidden,setHiddenMidAndIntFilters,midAndIntAndDateFilters,setMidAndIntAndDateFilters,suggestStartActive,setActiveSuggestStart}
  useEffect(
    () => {
      getDeviceType();
      getMap();
      if (isLogin()) {
        getCSRFtoken();
      }

      const interval = setInterval(() => {
        if (isLogin()) {
          getCSRFtoken();
        }
      }, timer);
      console.error = function () { }
      console.warn = function () { }
      console.clear()
    }, []
  )

  const getDeviceType = () => {
    const ua = navigator.userAgent;
    let full = window.location.host;
    //window.location.host is subdomain.domain.com
    let parts = full.split('.')
    let sub = parts[0]
    let domain = parts[1]
    let type = parts[2]
    let subDomain = domain + '.' + type;

    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) && subDomain === 'qcdevpro.com' && full !== 'www.qcdevpro.com') {
      window.location.href = 'https://www.qcdevpro.com';
    } else if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) && subDomain === 'data-point.io' && full !== 'www.data-point.io') {
      clearCacheData();
      window.location.href = 'https://www.qualitycounts.net/datapoint-redirect';
    } else if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) && full === 'www.data-point.io') {
      clearCacheData();
      window.location.href = 'https://www.qualitycounts.net/solutions-analyze-data';
    }

    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      ) && subDomain === 'qcdevpro.com' && full !== 'www.qcdevpro.com'
    ) {
      window.location.href = 'https://www.qcdevpro.com';
    } else if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      ) && subDomain === 'data-point.io' && full !== 'www.data-point.io'
    ) {
      clearCacheData();
      window.location.href = 'https://www.qualitycounts.net/datapoint-redirect';
    } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    ) && full === 'www.data-point.io') {
      clearCacheData();
      window.location.href = 'https://www.qualitycounts.net/solutions-analyze-data';
    }
  };

  const clearCacheData = () => {
    caches.keys().then((names) => {
        names.forEach((name) => {
            caches.delete(name);
        });
    });
  };

  const getCSRFtoken = () => { // API call to get CSRF token 
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getcsrftoken,
      })
        .then(async function (response) {
          if (response && response.data && response.data.csrfToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken; //set CSRF token in request headers
            getAccessToken(response.data.csrfToken);
          } else {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
            window.location.href = '/';
          }
        })
        .catch(function (error) {
          clearCookie('email');
          clearCookie('payload');
          clearCookie('idToken');
          clearCookie('atexpiry');
          clearCookie('alLogIn');
          window.location.href = '/';
        })
    } catch (error) {
      clearCookie('email');
      clearCookie('payload');
      clearCookie('idToken');
      clearCookie('atexpiry');
      clearCookie('alLogIn');
      window.location.href = '/';
    }
  }

  const getAccessToken = (csrfToken) => { //API call to request access token
    try {
      axios({
        method: 'post',
        data: {
          email: Cookies.get('email'),
          rememberMe: Cookies.get('alLogIn') == 'false' ? false : true
        },
        url: API_URL + API_PATH.getRefreshToken,
        'X-CSRF-TOKEN': csrfToken
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            if (response.data.payload) {
              setCookie('idToken', response.data.IdToken);
              setCookie('payload', response.data.payload);
              setCookie('atexpiry', response.data.access_token_expiry);
            } else {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
              window.location.href = '/';
            }
          } else {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
            window.location.href = '/';
          }
        })
        .catch(function (error) {
          clearCookie('email');
          clearCookie('payload');
          clearCookie('idToken');
          clearCookie('atexpiry');
          clearCookie('alLogIn');
          window.location.href = '/';
        })
    } catch (error) {
      clearCookie('email');
      clearCookie('payload');
      clearCookie('idToken');
      clearCookie('atexpiry');
      clearCookie('alLogIn');
      window.location.href = '/';
    }
  }

  const getMap = () => {
    isLoading(true);
    try {
      axios({
        method: 'post',
        data: {
          "subdomain": window.location.hostname
        },
        url: API_URL + API_PATH.getMapAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            let mapURLapi = response.data.data.url_map
            if(response.data.data.url_map) {
              sessionStorage.setItem('mapURL', response.data.data.url_map);
            } else {
              sessionStorage.setItem('mapURL', "https://services6.arcgis.com/VFCL16jxpNYJvQhh/ArcGIS/rest/services/int_stations/FeatureServer");
            }
            sessionStorage.setItem('agency_id', response.data.data.agency_id)
            sessionStorage.setItem('displayName', response.data.data.display_name)
            sessionStorage.setItem('layersFlag', response.data.data.layers_flag)
            sessionStorage.setItem('isKph', response.data.data.isKph)
            mapData(mapURLapi);
          } else {
            isLoading(false);
          }
        })
        .catch(function (error) {
          console.log(error);
          isLoading(false);
        })
    } catch (error) {
      console.error(error);
    }
  }

  const mapData = (mapURLapi) => {
    var bodyFormData = new FormData();
    bodyFormData.append('f', 'json',);
    bodyFormData.append('where', '1=1',);
    bodyFormData.append('outSr', '4326',);
    bodyFormData.append('outFields', 'TRL_NAME,ELEV_FT,CITY_JUR,PARK_NAME,FID');
    let instance = axios.create();
    delete instance.defaults.headers.common['X-CSRF-TOKEN'];
    try {
      instance({
        method: 'post',
        data: bodyFormData,
        url: mapURLapi,
        withCredentials: false
      })
        .then(async function (response) {
          await sessionStorage.setItem('subDomainName', response.data.name);
          isLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          isLoading(false);
        })
    } catch (error) {
      console.error(error);
      isLoading(false);
    }
  }

  return <>
  <MapContext.Provider value={filterdata}>
  <div className='appmainDiv'>
    {
      versionNum == 1 ?
        loading == false ?
          <> <Router>
            <Switch>
              <ProtectedRoute exact path="/UsersDashboard" component={UsersDashboard} />
              <ProtectedRoute exact path="/users_management" component={UserManagement} />
              <ProtectedRoute exact path="/data_management" component={DataManagement} />
              <ProtectedRoute exact path="/intersection_details" component={IntersectionDetails} />
              <ProtectedRoute exact path="/midblock_details" component={MidblockDetails} />
              <ProtectedRoute exact path="/file-import-requirements-and-best-practices" component={FileImportRequirementsAndBestPractices} />
    
              <UserRoute exact path="/set_new_password" component={ChangeAdminPassword} />
              <UserRoute exact path="/" component={Header} />
              <UserRoute exact path="/sign_in" component={Signin} />
              <UserRoute exact path="/sign_up" component={Signup} />
              <UserRoute exact path="/forgot_password" component={Forgotpassword} />
              <UserRoute exact path="/reset_password" component={ResetPassword} />
              <UserRoute exact path="/password_updated" component={PasswordUpdated} />
              <UserRoute exact path="/welcome" component={WelcomeNewUser} />
              <Route exact path="/under-maintenance" component={UnderMaintanance} />
              {
                isLogin() ?
                  <>
                    <Route exact path="/privacy_policy" component={PrivacyPolicy} />
                    <Route exact path="/help" component={Help} />
                    <Route exact component={PageNotFound} />
                  </>
                  :
                  <>
                    <Route exact path="/privacy_policy" component={PrivacyPolicy} />
                    <Route exact path="/help" component={Help} />
                    <Route exact component={PageNotFound} />
                  </>
              }
            </Switch>
            <Footer />
          </Router>
          </>
          : <div style={{
            width: '100%',
            textAlign: 'center',
            float: 'left',
            position: 'absolute',
            top: window.screen.width >= 1550 && window.screen.width <= 1750 ? '30%' : window.screen.width >= 1751 ? '35%' : '25%'
          }}>
            <img src={require('./assets/images/homeloader5.gif')} style={{ width: '200px' }} /></div>
      :
      loading == false ?
      <>
        <Router>
          <Switch>
            <ProtectedRoute exact path="/UsersDashboard" component={UsersDashboardV2} />
            <ProtectedRoute exact path="/intersection_details" component={IntersectionFullScreen} />
            <ProtectedRoute exact path="/midblock_details" component={MidblockFullScreen} />
            {/*<ProtectedRoute exact path="/file-import-requirements-and-best-practices" component={FileImport} />*/}
  
            <UserRoute exact path="/set_new_password" component={ChangeAdminPasswordv2} />
            <UserRoute exact path="/" component={Headerv2}  />
            <UserRoute exact path="/sign_in" component={SignIn} />
            <UserRoute exact path="/sign_up" component={SignUp} />
            <UserRoute exact path="/forgot_password" component={ForgotPassword} />
            <UserRoute exact path="/reset_password" component={ResetPasswordV2} />
            <UserRoute exact path="/password_updated" component={PasswordUpdatedV2} />
            <UserRoute exact path="/welcome" component={Welcome} />
            {/*<Route exact path="/help" component={HelpV2} />*/}
            {/*<Route exact path="/privacy_policy" component={PrivacyPolicyV2} />*/}
            <Route exact path="/under-maintenance" component={UnderMaintanance} />
            <Route exact component={PageNotFoundv2} />

          </Switch>
        </Router>
      </>
      : <div style={{
        width: '100%',
        textAlign: 'center',
        float: 'left',
        position: 'absolute',
        top: window.screen.width >= 1550 && window.screen.width <= 1750 ? '38%' : window.screen.width >= 1751 ? '35%' : '25%'
      }}>
        <img src={require('./assets/images/dataPointLogo.svg')} style={{ width: '250px',    marginBottom: '20px' }} />
        <div >
        <div className={'loader'}></div>
        </div>
        
        </div>
        
        
    }
    </div>
    </MapContext.Provider>
  </>
}

export default App;